import React, { useRef } from 'react';
import { Div } from '@icecreamsocial/components';

export const PageWrapper = ({ children, ...rest }) => {
	return (
		<Div padding={['md', 'md', 'xlg']} flexGrow="1" {...rest}>
			{children}
		</Div>
	);
};
